export default "__VITE_ASSET__cfbb2dbb__"